module.exports = __webpack_public_path__ + "img/ticket-sentosa.938e0993.svg";